import React from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { WebPlatform } from "@state/stores/types";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react";

export default observer(function MaintenanceNotice() {
	const { t } = useTranslation();

	const { maintenanceStore } = useRootAppStore<WebPlatform>();

	if (!maintenanceStore.isVisible) {
		return null;
	}

	return (
		<div className="message message--warning message--shadowy u-mar--bottom--sml u-padd--med">
			<div className="u-type--center">
				<i className="u-icon u-icon--huge u-icon--empty--maintenance u-color--sent--warning" />
				<div className="u-mar--y--tny u-type--xmed u-type--wgt--medium u-type--left">
					{t(`${maintenanceStore.maintenanceTitle}`)}
				</div>
				<div className="u-mar--bottom--xtny u-type--base u-type--left">
					{t(`${maintenanceStore.maintenanceDateMessage}`)}
				</div>
				{THEME_SETTINGS.isOasisEnabled ? (
					<div className="u-mar--bottom--xtny u-type--base u-type--left">
						{t(maintenanceStore.oasisMaintenanceDateMessage, {
							0: maintenanceStore.textDate,
							1: maintenanceStore.textTimeFrom,
							2: maintenanceStore.textTimeTo,
						})}
					</div>
				) : null}
				<div className="u-type--base u-type--left">
					{t(`${maintenanceStore.maintenanceDetailsMessage}`)}
				</div>
			</div>
		</div>
	);
});
